export default __webpack_public_path__ + "static/nexum-ec52202a8a89d42aa08033949a78e0cf.png";